<div class="flex items-center">
	@if (showEnvelopeDeleteLoading_()) {
		<i-tabler
			name="loader-2"
			class="animate-spin mr-2 text-gray-500 size-4 *:size-4"
		/>
	}
	<div class="flex flex-col gap-1">
		<p class="text-sm">{{ packageTypeLabel() }}</p>
		@if (packageTypes_()?.[isSigningPackageKey] === true && envelope_()) {
			<p class="text-gray-500 text-xs">{{ haveSignedCount_() }}</p>
		}
	</div>
</div>
